'use client'

import { toast } from 'sonner'
import { Button } from '@/components/ui/button'
import { openSupportChat } from '@/lib/support-chat'

export function OpenChatButton() {
  function handleOpenChat() {
    if (openSupportChat()) {
      return
    }

    toast.error(
      'O chat não está disponível no momento. Tente novamente em instantes ou fale conosco por e-mail.'
    )
  }

  return (
    <Button
      className="h-10 max-w-36 cursor-pointer font-semibold text-[#F8F9FA] text-sm transition-transform duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] active:scale-[0.97] motion-reduce:transition-none"
      onClick={handleOpenChat}
      type="button"
    >
      Converse agora
    </Button>
  )
}
